const urlWhats = 'https://api.whatsapp.com/send/?phone=554135277898&text=Ol%C3%A1%2C%20estou%20no%20site%20da%20RSMI%20Business%20e%20gostaria%20de%20uma%20cota%C3%A7%C3%A3o.&app_absent=0';

export default urlWhats;